module.exports = __webpack_public_path__ + "img/FlightSchool_Logo_DDFF00.4fb4ac65.png";